import { render, staticRenderFns } from "./leaderInfo.vue?vue&type=template&id=649534fa"
import script from "./leaderInfo.vue?vue&type=script&lang=js"
export * from "./leaderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports